import { render, staticRenderFns } from "./ElacMessage.vue?vue&type=template&id=f72296c4"
import script from "./ElacMessage.vue?vue&type=script&lang=js"
export * from "./ElacMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports